




























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component({
  inheritAttrs: false
})
export default class PopupNotification extends Vue {
  @Prop({ default: 'خطا در برقراری ارتباط با سرور' }) readonly title!: string
  @Prop({ default: 'لطفا مجدد امتحان کنید و در صورت وجود مشکل، کمی دیرتر سر بزنید' }) readonly message!: string
  @Prop({ default: 'info' }) readonly type!: string

  get setType() {
    const type = this.type
    if (type === 'success') {
      return {
        icon: 'check_circle',
        border: 'border-green',
        shadow: 'shadow-green',
        background: 'bg-tes-green',
        color: 'color-green'
      }
    } else if (type === 'warning') {
      return {
        icon: 'error',
        border: 'border-orange',
        shadow: 'shadow-orange',
        background: 'bg-tes-orange',
        color: 'color-orange'
      }
    } else {
      return {
        icon: 'info',
        border: 'border-navy-blue',
        shadow: 'shadow-navy-blue',
        background: 'bg-tes-navy-blue',
        color: 'color-navy-blue'
      }
    }
  }
}
